import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { KiService } from '../ki.service';

@Component({
  selector: 'sb-comp-ki',
  standalone: false,
  templateUrl: './ki.component.html',
  styleUrl: './ki.component.scss',
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KiComponent implements OnInit {
  protected readonly kiService = inject(KiService);

  newMessage: string = '';

  ngOnInit() {
    this.kiService.init();
    /*
    this.httpClient
      .get('/bernd/history', {
        headers: { 'X-Client-Id': 'seatback_test' },
      })
      .subscribe({
        next: response => {
          console.log(response);
        },
      });
    this.httpClient
      .post(
        '/bernd/navigation',
        {
          message: 'hallo! gib mir alle geräte mit channel Full Hd ' + Date.now().toString(),
        },
        {
          headers: { 'X-Client-Id': 'seatback_test' },
        }
      )
      .subscribe({
        next: response => {
          console.log(response);
        },
      });
     */
  }

  send() {
    const text = this.newMessage.trim();
    if (!text || text.length < 1) {
      return;
    }
    this.kiService.sendMessage(text);
    this.newMessage = '';
  }
}
